import { render, staticRenderFns } from "./PdvCallSender.vue?vue&type=template&id=87a12500&scoped=true"
import script from "./PdvCallSender.vue?vue&type=script&lang=js"
export * from "./PdvCallSender.vue?vue&type=script&lang=js"
import style0 from "./PdvCallSender.vue?vue&type=style&index=0&id=87a12500&prod&lang=css"
import style1 from "./PdvCallSender.vue?vue&type=style&index=1&id=87a12500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a12500",
  null
  
)

export default component.exports